<!--
 * @Author: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @Date: 2024-05-06 15:05:57
 * @LastEditors: 5CD2160XDH\shijun shijun1@haosen.com.cn
 * @LastEditTime: 2024-05-24 15:23:36
 * @FilePath: \hszy-official-website\src\views\SolutionCases\SolutionCaseDel.vue
 * @Description: 解决方案详情
-->
<template>
  <Container>
    <div
      v-if="isMobile"
      class="container solution-wrapper"
      @touchstart.prevent="handleTouchStart"
      @touchend.prevent="handleTouchEnd"
      @touchmove.prevent="handleTouchmove"
    >
      <div class="container main-body">
        <img :src="bannerPhone" alt="解决方案" class="banner">
        <div class="phone-content">
          <div class="block">
            <div class="title-text">{{ info.heading1 }}</div>
            <img :src="`/picture/${info.img1}`" alt="段落配图" class="pic">
            <!-- <div class="text">{{ info.description1 }}</div> -->
            <div class="text" v-html="text1" />
          </div>
          <div class="block">
            <div class="title-text">{{ info.heading2 }}</div>
            <img :src="`/picture/${info.img2}`" alt="段落配图" class="pic">
            <!-- <div class="text">{{ info.description2 }}</div> -->
            <div class="text" v-html="text2" />
          </div>
          <div class="block">
            <div class="title-text">{{ info.heading3 }}</div>
            <img :src="`/picture/${info.img3}`" alt="段落配图" class="pic">
            <!-- <div class="text">{{ info.description3 }}</div> -->
            <div class="text" v-html="text3" />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="container"
      @touchstart.prevent="handleTouchStart"
      @touchend.prevent="handleTouchEnd"
      @touchmove.prevent="handleTouchmove"
    >
      <div class="container main-body">
        <img :src="banner" alt="解决方案" class="banner">
        <div class="case-title">{{ info.subject }}</div>
        <div class="block">
          <img :src="`/picture/${info.img1}`" alt="段落配图" class="pic">
          <div class="content">
            <div class="title-text">{{ info.heading1 }}</div>
            <div class="text">{{ info.description1 }}</div>
          </div>
        </div>
        <div class="block-reverse">
          <img :src="`/picture/${info.img2}`" alt="段落配图" class="pic">
          <div class="content">
            <div class="title-text">{{ info.heading2 }}</div>
            <div class="text">{{ info.description2 }}</div>
          </div>
        </div>
        <div class="block">
          <img :src="`/picture/${info.img3}`" alt="段落配图" class="pic">
          <div class="content">
            <div class="title-text">{{ info.heading3 }}</div>
            <div class="text">{{ info.description3 }}</div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import banner from '@/assets/SolutionCases/banner.jpg'
import bannerPhone from '@/assets/SolutionCases/bannerPhone.jpg'
import Container from '@/components/Container'
import { findSolutionById } from '../../api'
import enquire from 'enquire-js'

export default {
  name: 'SolutionCaseDel',
  components: { Container },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      banner,
      bannerPhone,
      info: {
        subject: ''
      },
      isMobile: false
    }
  },
  computed: {
    text1() {
      return this.info.description1 && this.info.description1.replace(new RegExp('\n', 'gm'), '<br>')
    },
    text2() {
      return this.info.description2 && this.info.description2.replace(new RegExp('\n', 'gm'), '<br>')
    },
    text3() {
      return this.info.description3 && this.info.description3.replace(new RegExp('\n', 'gm'), '<br>')
    }
  },
  watch: {
    $route(to, from) {
      findSolutionById({
        id: this.id
      }).then(response => {
        this.info = response.data && response.data[0] ? response.data[0] : {}
      })
    }
  },
  mounted() {
    enquire.register('screen and (max-width: 1200px)', {
      match: () => {
        this.isMobile = true
      },
      unmatch: () => {
        this.isMobile = false
      }
    })
  },
  created() {
    findSolutionById({
      id: this.id
    }).then(response => {
      this.info = response.data && response.data[0] ? response.data[0] : {}
    })
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.banner {
  position: relative;
  left: 50%;
  margin-left: -960px;
}
.case-title {
  // display: block
  @include secondTitle;
  padding-top: 28px;
  text-align: center;
  color: #222;
  font-weight: bold;
  font-size: 42px;
  &::before {
    position: relative;
    top: 52px;
    right: 400px;
    content: '';
    display: block;
    width: 600px;
    height: 4px;
    border-top: 1px solid #dfdfdf;
    margin: 0 auto 20px;
  }
  &::after {
    position: relative;
    top: -22px;
    left: 400px;
    content: '';
    display: block;
    width: 600px;
    height: 4px;
    border-top: 1px solid #dfdfdf;
    margin: 0 auto 20px;
  }
}
.main-body {
  padding-bottom: 120px;
}

.news-img {
  height: 520px;
  width: 780px;
  margin: 40px 210px 0;
}

.block {
  margin-bottom: 90px;
  padding-right: 10px;
  border-right: 3px solid #3c3491;
  display: flex;
  flex-direction: row;
  .pic {
    margin-right: 70px;
    width: 491px;
    height: 276px;
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    .title-text {
      font-size: 22px;
      color: #3c3491;
      text-align: right;
    }
    .text {
      margin-top: 18px;
      font-size: 16px;
      line-height: 28px;
      color: #333;
      text-align: justify;
    }
  }
}

.block-reverse {
  margin-bottom: 90px;
  padding-left: 10px;
  border-left: 3px solid #3c3491;
  display: flex;
  flex-direction: row-reverse;
  .pic {
    margin-left: 70px;
    width: 491px;
    height: 276px;
  }
  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    .title-text {
      font-size: 22px;
      color: #3c3491;
      text-align: left;
    }
    .text {
      margin-top: 18px;
      font-size: 16px;
      line-height: 28px;
      color: #333;
      text-align: justify;
    }
  }
}

@media screen and (max-width: 1200px) {
  .solution-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
  .banner {
    width: 100%;
    left: 0;
    margin-left: 0;
  }
  .block {
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: none;
    .pic {
      width: 100% !important;
      height: auto !important;
      margin: 0 0 20px;
    }
  }
  .title-text {
    margin-bottom: 20px;
    font-size: 24px;
    color: #3c3491;
    text-align: center;
  }
  .text {
    font-size: 14px;
    line-height: 28px;
    color: #333;
    margin-bottom: 20px;
  }
  .title {
    padding-top: 20px;
  }
  .main-body {
    padding-bottom: 40px;
  }
  .phone-content {
    padding: 20px 20px 0;
  }
}
</style>
